/* Amazon-style cents for prices that are built in JavaScript.
 *
 * Liquid prices go through snippets/price-as-money.liquid, which superscripts the cents when
 * settings.superscript_decimals is on. That snippet covers the product cards, the PDP price, the
 * cart and the order pages — but roughly half the money on this site is painted by JS (the variant
 * popup, Frequently-Bought-Together, instant search, the Autoship portal), and each of those had
 * its own formatter. Without this they would sit next to a superscripted price showing a flat one.
 *
 * llmMoney.cents(str)  formatted string in  -> HTML out   ("$28.99"  -> '$28<sup class="llm-cents">99</sup>')
 * llmMoney.fromCents(n) integer cents in    -> HTML out   (2899      -> same)
 *
 * Output is HTML, so every caller must use innerHTML. That is safe here and only here: the input is
 * always a price this site generated, and the function does not pass anything through untouched —
 * it re-escapes each captured piece and inserts the only markup itself.
 *
 * Loaded early (not deferred) from layout/theme.liquid so it is defined before any of the scripts
 * that call it run.
 */
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Splits on the LAST decimal separator followed by exactly two digits, so thousands separators
     are left alone: "$1,234.56" keeps its comma and superscripts "56". The lazy head plus the
     trailing non-digit group is what forces that — "$1" + "," + "23" fails because "4.56" still
     has digits in it, and the match backtracks to the real separator. */
  var RE = /^(.*?)([.,])(\d{2})(\D*)$/;

  /* Everything before the first digit — "$", "US$ ", "CA$" — so the currency symbol can be raised
     and shrunk with the cents. Amazon does this: measured on their mobile PDP, .a-price-symbol and
     .a-price-fraction are BOTH 13px against a 28px whole number. Leaving the "$" full height is what
     made our price look wrong next to theirs (owner 2026-09-06: "I knew something was messing with
     my eyes"). */
  var SYM = /^([^\d]*)([\s\S]*)$/;

  function cents(value) {
    var str = String(value == null ? '' : value);
    var m = str.match(RE);
    // No cents to lift (whole-dollar formats, "Free", "—", an empty string): return it unchanged.
    if (!m) return esc(str);
    var head = m[1].match(SYM);
    var symbol = head[1]
      ? '<sup class="llm-currency">' + esc(head[1]) + '</sup>'
      : '';
    return symbol + esc(head[2]) + '<sup class="llm-cents">' + esc(m[3]) + '</sup>' + esc(m[4]);
  }

  /* Mirrors the money() helpers that already exist in llm-fbt.js and page.account.liquid: integer
     cents, comma-grouped, using the shop's own format string so a currency change does not need a
     code change. */
  function fromCents(n) {
    var amount = (Number(n || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    return cents(fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount));
  }

  window.llmMoney = { cents: cents, fromCents: fromCents };
})();
